var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionDesignInitiativeApplication.jinja');
require('./ProductionDesignInitiativeApplication.less');

var ProductionDesignInitiativeApplicationUpload = require('front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationUpload');

var ProductionDesignInitiativeApplicationMedia = require('front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMedia');
var ProductionDesignInitiativeApplicationMediaTemplate = require('front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplicationMediaRuntime.jinja');



module.exports = Base.extend({

    template: template,

    events: {
        'focus .ProductionDesignInitiativeApplication-form-inputWrapper--other input': 'onOtherInputFocus',
        'click .ProductionDesignInitiativeApplication-form-radio-label[for="ProductionDesignInitiativeApplication-howDidYouHear-o"]': 'onOtherClick',
        'click .ProductionDesignInitiativeApplication-mediaAdd': 'onAddMediaClick',

        'click .ProductionDesignInitiativeApplication-form input': 'resetErrorState',
        'change .ProductionDesignInitiativeApplication-form input': 'resetErrorState',
        'focus .ProductionDesignInitiativeApplication-form input': 'resetErrorState',
        'input .ProductionDesignInitiativeApplication-form input': 'onInputChange',
        'click .ProductionDesignInitiativeApplication-agreementLink': 'onAgreementPopupClick',
        'change input[type="radio"]': 'onRadioChange'
    },


    initialize: function (options) {
        this.options = options || {};

        var self = this;

        this.$('.ProductionDesignInitiativeApplicationUpload').each(function () {
            var uploadInstance = new ProductionDesignInitiativeApplicationUpload({
                el: this
            });

            $(this).data('instance', uploadInstance);
        });

        this.$('.ProductionDesignInitiativeApplicationMedia').each(function () {
            var mediaInstance = new ProductionDesignInitiativeApplicationMedia({
                el: this
            });

            self.listenTo(mediaInstance, 'delete', self.checkAddNewMediaButtonVisibility);

            $(this).data('instance', mediaInstance);
        });


        this.phoneInputHandler = app.utils.phoneInputHandler({
            phone0: this.$('input[name="daytimePhone0"]'),
            phone1: this.$('input[name="daytimePhone1"]'),
            phone2: this.$('input[name="daytimePhone2"]')
        });

        this.initialData = this.getFormData();

        Base.prototype.initialize.call(this, options);
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    deactivate: function (params) {

        this.phoneInputHandler && this.phoneInputHandler.destroy();

        this.$('.ProductionDesignInitiativeApplicationUpload').each(function () {
            var uploadInstance = $(this).data('instance');

            uploadInstance.deactivate();
        });

        this.$('.ProductionDesignInitiativeApplicationMedia').each(function () {
            var mediaInstance = $(this).data('instance');

            mediaInstance.deactivate();
        });

        return Base.prototype.deactivate.call(this, params);
    },


    onAgreementPopupClick: function (e) {
        e.stopPropagation();
        e.preventDefault();

        this.trigger('show-agreement');
    },


    onInputChange: function (e) {
        this.resetErrorState(e);
    },


    hasChanges: function () {

        return JSON.stringify(this.initialData) != JSON.stringify(this.getFormData());
    },


    resetErrorState: function (e) {
        $(e.currentTarget)
            .closest('.ProductionDesignInitiativeApplication-form-inputLine')
            .removeClass('ProductionDesignInitiativeApplication-form-inputLine--error ProductionDesignInitiativeApplication-form-inputLine--error-with-input');
    },


    checkAddNewMediaButtonVisibility: function () {
        var mediaCount = this.$('.ProductionDesignInitiativeApplicationMedia').length;

        this.$('.ProductionDesignInitiativeApplication-mediaAdd').toggleClass('ProductionDesignInitiativeApplication-mediaAdd--hidden', mediaCount >= 3);
    },


    onAddMediaClick: function () {
        var $template = $(ProductionDesignInitiativeApplicationMediaTemplate.render({
            data: {}
        }));

        this.$('.ProductionDesignInitiativeApplication-media').append($template);

        var mediaInstance = new ProductionDesignInitiativeApplicationMedia({
            el: $template[0]
        });

        $template.data('instance', mediaInstance);

        this.listenTo(mediaInstance, 'delete', this.checkAddNewMediaButtonVisibility);

        this.checkAddNewMediaButtonVisibility();
    },


    onOtherInputFocus: function () {
        this.$('#ProductionDesignInitiativeApplication-howDidYouHear-o')[0].checked = true;
    },


    onOtherClick: function () {
        this.$('.ProductionDesignInitiativeApplication-form-inputWrapper--other input').focus();
    },


    checkRequired: function () {
        var hasError = false;
        var self = this;

        //check form inputs
        this.$('.ProductionDesignInitiativeApplication-form-inputName--required').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.ProductionDesignInitiativeApplication-form-inputLine');
            var $input = $('input', $wrapper).eq(0);
            var inputName = $input.attr('name');
            var inputType = $input.attr('type');

            if (inputType == 'radio') {
                var val = self.$('input[name="' + inputName + '"]:checked').val();

                if (val == undefined) {
                    $wrapper.addClass('ProductionDesignInitiativeApplication-form-inputLine--error');
                    app.animateWindowScroll($wrapper.offset().top - 80);
                    hasError = true;

                    return;
                }

                if (inputName == 'howDidYouHear' && val == 'o') {
                    var $otherInput = $('input[type="text"]', $wrapper);
                    var val = $.trim($otherInput.val());

                    if (!val) {
                        $otherInput.focus();
                        $wrapper.addClass('ProductionDesignInitiativeApplication-form-inputLine--error-with-input');
                        app.animateWindowScroll($wrapper.offset().top - 80);
                        hasError = true;

                        return;
                    }
                }
            } else {
                var val = $.trim($input.val());

                /*eslint-disable */
                if (inputName == 'daytimePhone0') {
                    val = $('input', $wrapper).eq(0).val() && $('input', $wrapper).eq(1).val() && $('input', $wrapper).eq(2).val();
                }
                /*eslint-enable */

                if (!val) {
                    $input.focus();
                    $wrapper.addClass('ProductionDesignInitiativeApplication-form-inputLine--error-with-input');
                    app.animateWindowScroll($wrapper.offset().top - 80);
                    hasError = true;

                    return;
                }
            }
        });

        if (hasError) return false;



        //check uploads
        this.$('.ProductionDesignInitiativeApplicationUpload').each(function () {
            if (hasError) return;

            var uploadInstance = $(this).data('instance');
            var uploadInstanceData = uploadInstance.getData();
            var $wrapper = $(this).closest('.ProductionDesignInitiativeApplication-upload');

            if (!uploadInstanceData.file) {
                $wrapper.flashClass('ProductionDesignInitiativeApplication-upload--error', 1000);
                app.animateWindowScroll($wrapper.offset().top);
                hasError = true;

                return;
            }
        });

        if (hasError) return false;



        //check media
        this.$('.ProductionDesignInitiativeApplicationMedia').each(function () {
            if (hasError) return;

            var mediaInstance = $(this).data('instance');
            var mediaInstanceData = mediaInstance.getData();
            var $wrapper = $(this).closest('.ProductionDesignInitiativeApplication-media');

            if (mediaInstanceData.videoUrl && !mediaInstanceData.videoCode) {
                $wrapper.flashClass('ProductionDesignInitiativeApplication-media--error', 1000);
                app.animateWindowScroll($wrapper.offset().top);
                hasError = true;

                return;
            }
        });

        if (hasError) return false;




        //check aggreements
        this.$('.ProductionDesignInitiativeApplication-agreement input').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.ProductionDesignInitiativeApplication-agreement-checkboxWrapper');
            var $input = $('input', $wrapper).eq(0);

            if (!$input.is(':checked')) {
                $wrapper
                    .closest('.ProductionDesignInitiativeApplication-agreement')
                    .flashClass('ProductionDesignInitiativeApplication-agreement--error', 1000);
                app.animateWindowScroll($wrapper.offset().top - 80);
                hasError = true;

                return;
            }
        });


        return !hasError;
    },


    getFormData: function () {
        var data = {
            'isAppliedBefore': this.$('input[name="isAppliedBefore"]:checked').val() == '1' ? true : this.$('input[name="isAppliedBefore"]:checked').val() == '0' ? false : null,
            'firstName': this.$('input[name="firstName"]').val(),
            'lastName': this.$('input[name="lastName"]').val(),
            'daytimePhone': this.$('input[name="daytimePhone0"]').val() + '-' + this.$('input[name="daytimePhone1"]').val() + '-' + this.$('input[name="daytimePhone2"]').val(),
            'email': this.$('input[name="email"]').val(),
            'address': this.$('input[name="address"]').val(),
            'addressLine2': this.$('input[name="addressLine2"]').val(),
            'city': this.$('input[name="city"]').val(),
            'state': this.$('input[name="state"]').val(),
            'zip': this.$('input[name="zip"]').val(),
            'country': this.$('input[name="country"]').val(),
            'website1': this.addHttp(this.$('input[name="website1"]').val()),
            'website2': this.addHttp(this.$('input[name="website2"]').val()),
            'isEligibleToWork': this.$('input[name="isEligibleToWork"]:checked').val() == '1' ? true : this.$('input[name="isEligibleToWork"]:checked').val() == '0' ? false : null,
            'howDidYouHear': this.$('input[name="howDidYouHear"]:checked').val(),

            /*eslint-disable */
            'narrativePdf': this.$('.ProductionDesignInitiativeApplicationUpload[data-name="narrativePdf"]').data('instance').getData().file,
            'resumePdf': this.$('.ProductionDesignInitiativeApplicationUpload[data-name="resumePdf"]').data('instance').getData().file,
            'recommendationPdf1': this.$('.ProductionDesignInitiativeApplicationUpload[data-name="recommendationPdf1"]').data('instance').getData().file,
            'recommendationPdf2': this.$('.ProductionDesignInitiativeApplicationUpload[data-name="recommendationPdf2"]').data('instance').getData().file,
            'portfolioPdf': this.$('.ProductionDesignInitiativeApplicationUpload[data-name="portfolioPdf"]').data('instance').getData().file,
            /*eslint-enable */

            media: []
        };

        if (data.howDidYouHear == 'o') {
            data.howDidYouHearOther = this.$('input[name="howDidYouHearOther"]').val();
        }

        this.$('.ProductionDesignInitiativeApplicationMedia').each(function () {
            var mediaInstance = $(this).data('instance');
            var mediaInstanceData = mediaInstance.getData();

            if (mediaInstanceData.videoUrl && mediaInstanceData.videoCode) {
                data.media.push(mediaInstanceData);
            }
        });

        console.log(data);

        return data;
    },


    addHttp: function (str) {
        if (!str) return '';

        if (!/^https?:\/\//.test(str)) {
            return 'http://' + str;
        } else {
            return str;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionDesignInitiativeApplication/ProductionDesignInitiativeApplication.js
// module id = 231
// module chunks = 0